import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { getFlattenedTreeWithAncestry } from '@/nestedRows';

import getAxiosConfig from '../helpers/getAxiosConfig';
import handleAdminVideoAxiosError from '../helpers/handleAdminVideoAxiosError';

export default ({ isTopicsPage }) => {
  const { id, orgId } = useParams();

  const videosAdminTreeKey = useMemo(() => ['videosAdminTree', orgId, id], [orgId, id]);
  const videosAdminTree = useQuery(
    videosAdminTreeKey,
    async () => {
      try {
        const {
          data: { data },
        } = await axios(getAxiosConfig('get-videos-admin-tree', { orgId }));
        return data;
      } catch (error) {
        handleAdminVideoAxiosError(error);
      }
    },
    {
      enabled: isTopicsPage,
    },
  );

  const flattenedVideosAdminTreeKey = useMemo(
    () => ['flattenedVideosAdminTree', videosAdminTree.data],
    [videosAdminTree.data],
  );
  const flattenedVideosAdminTree = useQuery(
    flattenedVideosAdminTreeKey,
    () => getFlattenedTreeWithAncestry({ data: videosAdminTree.data }),
    {
      enabled: !!videosAdminTree.data,
    },
  );

  return {
    videosAdminTree,
    videosAdminTreeKey,
    flattenedVideosAdminTree,
    flattenedVideosAdminTreeKey,
  };
};
